import { createSlice } from '@reduxjs/toolkit';

export const rerenderSlice = createSlice({
  name: 'rerender',
  initialState: {
    subpanels: {},
  },
  reducers: {
    triggerRerender: (state, action) => {
      const { subpanelId } = action.payload;
      state.subpanels[subpanelId] = (state.subpanels[subpanelId] || 0) + 1;
    },
  },
});

export const { triggerRerender } = rerenderSlice.actions;

export const selectSubpanelRerender = (state, subpanelId) => state.rerender.subpanels[subpanelId] || 0;

export default rerenderSlice.reducer;
